module.exports = __webpack_public_path__ + "media/images/favicons/favicon-wednesday-93d144fe0ca97a9234b9f17ab9144ceb.ico";